import React from 'react';
import { Row, Col} from 'antd';
import { Button, Select, Checkbox} from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const { Option } = Select;

export function PlotMenu({encuestas, handleEncuesta, handleLegend, handleDownload}){

    return(
            <div className="upper-menu">
                    <Row>
                        {/* <Col xs={{span: 12, offset: 0, order: 3}} md={{span: 3, offset: 0, order: 1}}>
                            <div className = "label-box">
                                <a className="legend-label" onClick={handleLegend} name = "apruebo" href=" " id = "apruebo-label"><span className = "legend" id="apruebo"></span>Apruebo</a>     
                            </div>
                        </Col>
                        <Col xs={{span: 10, order: 4}} md={{span: 3, order: 2}}>
                            <div className = "label-box">
                                <a className="legend-label" onClick={handleLegend} name = "rechazo" href=" " id = "rechazo-label"><span className = "legend" id="rechazo"></span>Rechazo</a>
                            </div>    
                        </Col> */}

                        <Col xs={{span: 12, offset: 0, order: 3}} lg={{span: 3, offset: 0, order: 1}}>
                            <div className = "label-box">
                                <Checkbox style={{ fontSize: 'calc(12px + 0.4vw)' }} defaultChecked onChange={handleLegend} className="legend apruebo" name="apruebo" id="apruebo">Apruebo</Checkbox>
                            </div>
                        </Col>

                        <Col xs={{span: 10, order: 4}} lg={{span: 3, order: 2}}>
                            <div className = "label-box">
                                <Checkbox style={{ fontSize: 'calc(12px + 0.4vw)' }} defaultChecked onChange={handleLegend} className="legend rechazo" name="rechazo" id="rechazo">Rechazo</Checkbox>
                            </div>    
                        </Col>

                        <Col xs={{span: 20, offset: 0, order: 1}} lg={{span: 6, offset: 2, order: 3}} className = "select-medios">
                            <Select size={'large'} defaultValue="Todas las encuestas" style={{ width: '90%', height: '100%', color: '#828282', fontSize: 'calc(12px + 0.2vw)', borderColor: '#828282' }} onChange={handleEncuesta} id="SelectMedios"
                            className = "select-medios">
                                {encuestas.map(function(object, i){
                                    return <Option value={object} key={i}> {object} </Option>;
                                })}
                            </Select>
                        </Col>


                        <Col xs={{span: 2, offset: 0, order: 2}} lg={{span: 1, offset: 4, order: 4}}>
                            <Button type="primary" ghost icon={<DownloadOutlined onClick={handleDownload}/>} size="large"/>
                        </Col>
                    </Row>
            </div>
    )

};